import { ObservationSource } from '@jack-henry/frontend-utils/observable';
import { PropertyValues } from 'lit';
import { TmBaseComponent } from '../../tm-base.component';
import { ISideDrawerContent, SideDrawerButton } from './side-drawer.service.types';

/**
 * A class consumers can extend to afford additional customization with how they
 * interact with `TmSideDrawerService` and the `<tm-side-drawer>` component.
 *
 * Extending this class will enable the side drawer chrome to respond
 * to reactive property changes in the component.
 */
export abstract class TmSideDrawerContent<T = unknown>
    extends TmBaseComponent
    implements ISideDrawerContent<T>
{
    protected readonly drawerProvider = new SideDrawerProvider<T>();

    private readonly updatedSource = new ObservationSource<PropertyValues>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly updated$ = this.updatedSource.toObservable();

    public get drawerButtons() {
        return this.drawerProvider.drawerButtons;
    }

    protected updated(changedProps: PropertyValues) {
        super.updated(changedProps);
        this.updatedSource.emit(changedProps);
    }
}

/**
 * Allows a component to specify configuration in a way that is
 * encapsulated within the class itself.
 */
class SideDrawerProvider<T = unknown> {
    private _drawerButtons?: SideDrawerButton<T>[];

    public get drawerButtons() {
        return this._drawerButtons;
    }

    /**
     * Specify an array of button configuration objects
     * to be used by `TmSideDrawerService`
     */
    public provideButtons(buttons: SideDrawerButton<T>[]) {
        this._drawerButtons = buttons;
        return this;
    }
}
